/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgBackToBack = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <path
        d="M4 2h16v6h-2V4H6v4H4zm8 6a1 1 0 1 0 0 2 1 1 0 0 0 0-2zM9 9a3 3 0 1 1 6 0 3 3 0 0 1-6 0zm-4.914 4-1.793-1.793 1.414-1.414L6.914 13l-3.207 3.207-1.414-1.414zm16.207-3.207 1.414 1.414L19.914 13l1.793 1.793-1.414 1.414L17.086 13zM12 15a2 2 0 0 1 2 2h-1v3h-2v-3h-1a2 2 0 0 1 2-2zm3 4h1v-2a4 4 0 0 0-8 0v2h1v3h6z"
        fill="currentcolor"
      />
    </g>
  </Icon>
);
export { SvgBackToBack as BackToBack };
